export default __webpack_public_path__ + "static/media/Group332.27ee75a0.png";